import styles from './Checkbox.module.css';
import { Check } from 'lucide-react';
interface props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Dark glass auth card (login remember-me) */
  variant?: 'default' | 'auth';
  id?: string;
}
export function Checkbox({ checked, onChange, variant = 'default', id }: props) {
  const isAuth = variant === 'auth';
  return (
    <>
      {id ? (
        <input
          type='checkbox'
          id={id}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className={styles.nativeInput}
        />
      ) : null}
      <div
        className={
          isAuth
            ? `${styles.authCheckbox} ${!checked ? styles.authCheckboxUnchecked : ''}`
            : `${styles.customCheckbox} ${!checked && styles.unchecked}`
        }
        onClick={() => onChange(!checked)}
        aria-hidden={id ? true : undefined}
      >
        {checked == true && (
          <Check width={isAuth ? 9 : 19} height={isAuth ? 9 : 15} strokeWidth={isAuth ? 3 : 2} />
        )}
      </div>
    </>
  );
}
